export const ITEM_TYPE_PRODUCT = "Product";
export const ITEM_TYPE_VOUCHER = "Voucher";
export const ITEM_TYPE_SUBSCRIPTION = "Subscription";
